export default __webpack_public_path__ + "static/GT-America-Mono-Regular-Italic-cbb3ce2fe5d4aaa34ab34445b4b2ba5f.woff2";